import { useEffect, useState } from 'react';
import type { Article } from '@/types';
import { api } from '@/client/lib/api';
import { EditorialCard } from '@/components/ArticleView';
import { useI18n } from '@/client/i18n/I18nContext';
import { localizeArticle } from '@/lib/i18n-content';

/**
 * Product page → «En el Edit»: the published Edit articles that link this
 * product (`relatedProductSlugs`), filtered server-side (`?product=`; scheduled
 * articles are hidden there too). Renders nothing when no article links it.
 */
export function ProductArticles({ productSlug }: { productSlug: string }) {
  const { t, locale } = useI18n();
  const [articles, setArticles] = useState<Article[]>([]);

  useEffect(() => {
    let alive = true;
    setArticles([]);
    api
      .articlesForProduct(productSlug)
      .then((list) => {
        if (alive) setArticles(list);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [productSlug]);

  if (articles.length === 0) return null;
  return (
    <section
      aria-labelledby="product-articles-title"
      style={{ marginTop: 'var(--space-8)', paddingTop: 'var(--space-6)', borderTop: 'var(--border-hairline)' }}
    >
      <h2 id="product-articles-title" className="eyebrow" style={{ marginBottom: 'var(--space-5)' }}>
        {t('product.editTitle')}
      </h2>
      <div className="editorial-grid">
        {articles.map((raw) => (
          <EditorialCard key={raw.id} article={localizeArticle(raw, locale)} />
        ))}
      </div>
    </section>
  );
}
